import { restClient } from '@/Core/Services/RestClientService'

/** POST /services/erp-exchange/{uuid}/process-import — запустити обробку запису вручну */
export const ProcessImportItemTask = async (uuid: string): Promise<Record<string, any>> => {
    const request = restClient.post(`/services/erp-exchange/${uuid}/process-import`, { json: {} })
    if (!request) throw new Error('restClient.post returned null')
    return (await request) as unknown as Record<string, any>
}
